import 'svelte/internal/disclose-version';

Study[$.FILENAME] = 'src/ui/Study.svelte';

import * as $ from 'svelte/internal/client';
import LoadError from "./LoadError.svelte";
import ReviewSession from "./ReviewSession.svelte";
import SetPicker from "./SetPicker.svelte";
import Settings from "./Settings.svelte";
import { describeError } from "./errors.ts";
import { hanziPromptsPaused } from "./settings.ts";

var root = $.add_locations(
	$.from_html(
		`
    <!>
  `,
		1
	),
	Study[$.FILENAME],
	[]
);

var root_1 = $.add_locations(
	$.from_html(
		`
    <!>
  `,
		1
	),
	Study[$.FILENAME],
	[]
);

var root_2 = $.add_locations(
	$.from_html(
		`
    <div class="home svelte-3dbt37vmmlgds">
      <!>
      <!>
    </div>
  `,
		1
	),
	Study[$.FILENAME],
	[[37, 4]]
);

var root_3 = $.add_locations(
	$.from_html(
		`

<div class="study svelte-3dbt37vmmlgds">
  <!>
</div>

`,
		1
	),
	Study[$.FILENAME],
	[[13, 0]]
);

export default function Study($$anchor, $$props) {
	$.check_target(new.target);
	$.push($$props, true, Study);

	var $$exports = { ...$.legacy_api() };

	$.next();

	var fragment = root_3();
	var div = $.sibling($.first_child(fragment));
	var node = $.sibling($.child(div));

	{
		var consequent = ($$anchor) => {
			var fragment_1 = root();
			var node_1 = $.sibling($.first_child(fragment_1));

			$.add_svelte_meta(
				() => LoadError(node_1, {
					get title() {
						return $$props.study.failure.title;
					},

					get error() {
						return $$props.study.failure.error;
					},

					get at() {
						return $$props.study.failure.at;
					},

					get busy() {
						return $$props.study.busy;
					},

					get onretry() {
						return $$props.study.failure.retry;
					},

					get onback() {
						return $$props.study.failure.back;
					},

					get backLabel() {
						return $$props.study.failure.backLabel;
					}
				}),
				'component',
				Study,
				15,
				4,
				{ componentTag: 'LoadError' }
			);

			$.next();
			$.append($$anchor, fragment_1);
		};

		var consequent_1 = ($$anchor) => {
			var fragment_2 = root_1();
			var node_2 = $.sibling($.first_child(fragment_2));

			$.add_svelte_meta(
				() => ReviewSession(node_2, {
					get session() {
						return $$props.study.session;
					},

					get now() {
						return $$props.study.now;
					},

					get busy() {
						return $$props.study.busy;
					},

					get onsubmit() {
						return $$props.study.submit;
					},

					get onretry() {
						return $$props.study.retry;
					},

					get onnext() {
						return $$props.study.next;
					},

					get onresume() {
						return $$props.study.resume;
					},

					get onend() {
						return $$props.study.end;
					},

					get onback() {
						return $$props.study.back;
					}
				}),
				'component',
				Study,
				25,
				4,
				{ componentTag: 'ReviewSession' }
			);

			$.next();
			$.append($$anchor, fragment_2);
		};

		var consequent_2 = ($$anchor) => {
			var fragment_3 = root_2();
			var div_1 = $.sibling($.first_child(fragment_3));
			var node_3 = $.sibling($.child(div_1));

			$.add_svelte_meta(
				() => SetPicker(node_3, {
					get sets() {
						return $$props.study.sets;
					},

					get now() {
						return $$props.study.now;
					},

					get focus() {
						return $$props.study.last;
					},

					get onstart() {
						return $$props.study.start;
					}
				}),
				'component',
				Study,
				38,
				6,
				{ componentTag: 'SetPicker' }
			);

			var node_4 = $.sibling(node_3, 2);

			{
				let $0 = $.derived(() => hanziPromptsPaused($$props.study.sets));
				let $1 = $.derived(() => $.strict_equals($$props.study.settingsError, null) ? null : describeError($$props.study.settingsError));

				$.add_svelte_meta(
					() => Settings(node_4, {
						get paused() {
							return $.get($0);
						},

						get busy() {
							return $$props.study.settingsBusy;
						},

						get error() {
							return $.get($1);
						},

						get onchange() {
							return $$props.study.pauseHanziPrompts;
						}
					}),
					'component',
					Study,
					39,
					6,
					{ componentTag: 'Settings' }
				);
			}

			$.next();
			$.reset(div_1);
			$.next();
			$.append($$anchor, fragment_3);
		};

		$.add_svelte_meta(
			() => $.if(node, ($$render) => {
				if ($$props.study.failure) $$render(consequent); else if ($$props.study.session) $$render(consequent_1, 1); else if ($$props.study.sets) $$render(consequent_2, 2);
			}),
			'if',
			Study,
			14,
			2
		);
	}

	$.next();
	$.reset(div);
	$.next();
	$.append($$anchor, fragment);

	return $.pop($$exports);
}
import "bun-svelte:Study.svelte-3ef4dpnro3ch7-style.css";